








import { Vue, Component, Prop } from "vue-property-decorator";

import { isOtherAllowedInput, isNumberInput } from "@share/common/controls/utils/charcodeCheckers"


@Component({})

export default class NumberInput extends Vue {
  @Prop({ default: "" }) value: string;
  @Prop({ default: "" }) placeholder: string;

  keydown(e: any) {
    const charCode = (e.which) ? e.which : e.keyCode;

    if(isOtherAllowedInput(charCode, e)) {
      return
    }

    if(!isNumberInput(charCode)){
      e.preventDefault();
    }
  }

}
